var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "PageTemplate" } },
    [
      _c(
        "div",
        {
          staticClass: "list-section",
          class: { hide: _vm.$route.query.details }
        },
        [
          _c("vo-list-header", {
            staticClass: "header",
            attrs: { page: _vm.page }
          }),
          _vm._v(" "),
          _c("vo-list", {
            staticClass: "list-item",
            attrs: {
              selectable: "",
              selected: _vm.page.selected,
              list: _vm.page.list,
              itemComponent: _vm.listComponent,
              lazy: ""
            },
            on: { itemSelected: _vm.openListItem }
          }),
          _vm._v(" "),
          _vm.page.fab && _vm.checkFab(_vm.page.fab.permissions)
            ? _c(
                "v-btn",
                {
                  staticClass: "fab",
                  attrs: { color: "accent", fab: "" },
                  on: { click: _vm.fabClicked }
                },
                [_c("v-icon", [_vm._v("mdi-plus")])],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(_vm.pageComponent, {
        tag: "component",
        staticClass: "page",
        class: {
          active: _vm.$route.query.details,
          "has-drawer": _vm.drawerComponent
        },
        attrs: { page: _vm.page }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "vo-scrim",
        class: { active: _vm.$route.query.filter },
        on: {
          click: function($event) {
            _vm.routeRemoveQuery("filter")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter", class: { active: _vm.$route.query.filter } },
        [
          _vm.page.filterComponent.cmp === "vo-filter"
            ? [_c("vo-filter", { attrs: { filtering: _vm.page.filtering } })]
            : _vm.page.filterComponent.cmp === "vo-filter-nav"
              ? [
                  _c("vo-filter-nav", {
                    attrs: {
                      links: _vm.page.filterComponent.params.links,
                      navElement: _vm.page.filterComponent.params.navElement
                    }
                  })
                ]
              : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "vo-scrim drawer-scrim",
        class: { active: _vm.$route.query[_vm.drawerQuery] },
        on: {
          click: function($event) {
            _vm.$router.go(-1)
          }
        }
      }),
      _vm._v(" "),
      _vm.drawerComponent
        ? _c(
            "div",
            {
              staticClass: "drawer",
              class: { active: _vm.$route.query[_vm.drawerQuery] }
            },
            [
              _c(_vm.drawerComponent, {
                tag: "component",
                attrs: { page: _vm.page }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-459e284e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-459e284e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTemplate.vue
// module id = 530
// module chunks = 4